import React, { useState } from "react";
import Navbar from "../DashBoardComponents/Navbar";
import Footer from "../DashBoardComponents/Footer";
import Chatbot from "../DashBoardComponents/Chatbot";
import chatbotimage4 from "../assets/images/chatbot4.png";
import chatbotimage3 from "../assets/images/chatbot3.png";
import ChatbotForPatient from "../DashBoardComponents/ChatbotForPatient";

function Layout({ children }) {
  const [active, setActive] = useState(false);

  const storedLoginResult = localStorage.getItem("patientData");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  return (
    <div className="flex flex-col">
      <div>
        <Navbar />
      </div>
      <div className="pt-[70px]">{children}</div>

      {loginResultObject?.patientId && (
        <div>
          {" "}
          {active ? (
            <ChatbotForPatient setActive={setActive} />
          ) : (
            <div className="chatbot-activate" onClick={() => setActive(true)}>
              <img src={chatbotimage3} alt="chatbot" />
            </div>
          )}
        </div>
      )}
      {!loginResultObject?.patientId && (
        <div>
          {" "}
          {active ? (
            <ChatbotForPatient setActive={setActive} />
          ) : (
            <div className="chatbot-activate" onClick={() => setActive(true)}>
              <img src={chatbotimage3} alt="chatbot" />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Layout;
